// 2026-09-14 - lightweight global pub/sub for "a mutation just happened, refetch this
// kind of data" (see api.js's response interceptor for the automatic publish side, and
// useRefreshListener below for the subscribe side). Deliberately NOT a new polling
// mechanism - zero added network cost, purely event-driven off calls that already happen.
const listeners = new Map(); // scope name -> Set<callback>

export function publish(scopes) {
  const list = Array.isArray(scopes) ? scopes : [scopes];
  const fired = new Set();
  list.forEach((scope) => {
    listeners.get(scope)?.forEach((cb) => {
      if (!fired.has(cb)) {
        fired.add(cb);
        cb();
      }
    });
  });
}

export function subscribe(scopes, callback) {
  const list = Array.isArray(scopes) ? scopes : [scopes];
  list.forEach((scope) => {
    if (!listeners.has(scope)) listeners.set(scope, new Set());
    listeners.get(scope).add(callback);
  });
  return () => list.forEach((scope) => listeners.get(scope)?.delete(callback));
}
